module.exports = __WEBPACK_EXTERNAL_MODULE_2__;


/*****************
 ** WEBPACK FOOTER
 ** external {"root":"d3","commonjs":"d3","commonjs2":"d3","amd":"d3"}
 ** module id = 2
 ** module chunks = 0
 **/